import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100 hoverLgreyBg rad10 pad10",
  style: {"min-height":"140px"}
}
const _hoisted_2 = {
  class: "fl fw600 fs20",
  style: {"width":"300px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  class: "fl fs12",
  style: {"width":"300px"}
}
const _hoisted_5 = {
  class: "fl",
  style: {"width":"100px"}
}
const _hoisted_6 = {
  key: 0,
  class: "fs11",
  style: {}
}
const _hoisted_7 = {
  class: "fl",
  style: {"width":"100px"}
}
const _hoisted_8 = { class: "fs14" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_AssignFormCellEditMenu = _resolveComponent("AssignFormCellEditMenu")!

  return (_ctx.aform)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.aform.title) + " ", 1),
            _hoisted_3,
            (_ctx.aform)
              ? (_openBlock(), _createBlock(_component_tooltip, {
                  key: 0,
                  text: "コピーしました!",
                  trigger: "manual",
                  modelValue: _ctx.showTip,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showTip) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      class: "fs12 ddgreyColor",
                      style: {"line-height":"16px"},
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyPublicId && _ctx.copyPublicId(...args)))
                    }, _toDisplayString(_ctx.aform.public_id), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.CalendarUtil.toJpFormat(_ctx.aform.updated_at, 0, true)), 1),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.aform.owner)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createVNode(_component_UserIcon, {
                    member: _ctx.aform.owner,
                    width: 22,
                    canEdit: false,
                    updateSelf: false,
                    showTooltip: true,
                    tooltipName: `オーナー: ${_ctx.aform.owner.name}`,
                    class: "fl ml10"
                  }, null, 8, ["member", "tooltipName"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.aform.status_name), 1),
            (_ctx.aform.is_owner_group)
              ? (_openBlock(), _createBlock(_component_AssignFormCellEditMenu, {
                  key: 0,
                  aform: _ctx.aform,
                  canDelete: true,
                  onCopyPage: _ctx.copyPage,
                  onEditPage: _ctx.editPage,
                  onShowCloseRoomModal: _ctx.showCloseRoomModal,
                  onClickEditMenu: _ctx.clickEditMenu
                }, null, 8, ["aform", "onCopyPage", "onEditPage", "onShowCloseRoomModal", "onClickEditMenu"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_9
        ])
      ]))
    : _createCommentVNode("", true)
}